module.exports = __webpack_public_path__ + "img/bleu.1e6d0b00.png";